export function addCurrencyFrequency(value, currency, frequency) {
  if (currency === '£' || currency === '$' || currency === '€') {
    if (frequency) {
      return `${currency}${value} ${frequency}`;
    } else {
      return `${currency}${value}`;
    }
  } else {
    if (frequency) {
      return `${value} ${currency} ${frequency}`;
    } else {
      return `${value} ${currency}`;
    }
  }
}

export function startAdornmentCurrency(currency) {
  if (currency === '£' || currency === '$' || currency === '€') {
    return currency
  } else {
    return null
  }
}

export function endAdornmentCurrencyFrequency(currency, frequency) {
  if (currency === '£' || currency === '$' || currency === '€') {
    return frequency
  } else {
    if (frequency) {
      return `${currency} ${frequency}`
    } else {
      return currency
    }
  }
}

export function endAdornmentCurrencyUnitFrequency(currency, unit, frequency) {
  if (currency === '£' || currency === '$' || currency === '€') {
    if (frequency && unit) {
      return `per ${unit} ${frequency}`
    } else if (frequency) {
      return frequency
    } else {
      return `per ${unit}`
    }
  } else {
    if (frequency && unit) {
      return `${currency} per ${unit} ${frequency}`
    } else if (frequency) {
      return `${currency} ${frequency}`
    } else if (unit) {
      return `${currency} per ${unit}`
    } else {
      return currency
    }
  }
}

export function addCurrency(value, currency) {
  if (currency === '£' || currency === '$' || currency === '€') {
    return `${currency}${value}`;
  } else {
    return `${value} ${currency}`;
  }
}